import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { loader } from "react-global-loader";
import { useLocation, useNavigate } from "react-router-dom";
import { _post } from "../services/api.service";

const Authenticate: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [authError, setAuthError] = useState<string | null>(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get("code");

    const handleAuth = async () => {
      loader.show();
      if (!code) {
        setAuthError("Missing authorization code in URL");
        loader.hide();
        return;
      }
      try {
        const formData = new FormData();
        formData.append("authorization_code", code);
        const userData = await _post("users/google_oauth/", formData);
        if (userData) {
          localStorage.setItem("TOKEN", userData.access);
          localStorage.setItem("REFRESH_TOKEN", userData.refresh);
          navigate("/");
        } else {
          navigate('/login')
        }
      } catch (err: any) {
        setAuthError("Authentication failed. Please try again.");
      } finally {
        loader.hide();
      }
    };

    handleAuth();
  }, [location, navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      sx={{ backgroundColor: "#000723", color: "#fff", textAlign: "center" }}
    >
      {authError ? (
        <Typography color="error" fontSize={18}>
          {authError}
        </Typography>
      ) : (
        <Typography color="#9da3b4" fontSize={16}>
          Authenticating, please wait...
        </Typography>
      )}
    </Box>
  );
};

export default Authenticate;
